window.addEventListener("turbolinks:load", function () {
  const isIndexPageBody = document.querySelector("body.is-roots-index")
  if (isIndexPageBody == null) return

  isIndexPageBody.dataset.turbolinks = "false"
})
